import { render, staticRenderFns } from "./ListBlastEmail.vue?vue&type=template&id=8093c81a&scoped=true&"
import script from "./ListBlastEmail.vue?vue&type=script&lang=js&"
export * from "./ListBlastEmail.vue?vue&type=script&lang=js&"
import style0 from "./ListBlastEmail.vue?vue&type=style&index=0&id=8093c81a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8093c81a",
  null
  
)

export default component.exports